import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faInfoCircle,
  faComment,
  faImages,
  faTicket,
  faBars,
  faCircleHalfStroke,
  faNewspaper,
  faTimes,
  faRss,
  faShoppingCart,
  faUserLock,
} from '@fortawesome/free-solid-svg-icons';
import '../styles/header.css';

const Header = ({ theme, toggleTheme }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className={`header ${theme}`}>
      <div className="logo-container">
        <Link to="/" title="Accueil" className="logo-link">
          <img
            src="/logo.png"
            alt="Logo Les Z'Ineuvitables"
            className="logo"
          />
        </Link>
      </div>

      <nav ref={menuRef} className={`nav-menu ${menuOpen ? 'open' : ''}`}>
        <button
          className="close-icon-button"
          onClick={toggleMenu}
          aria-label="Fermer le menu"
        >
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>

        <Link to="/" title="Accueil" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faHome} size="lg" />
          <span>Accueil</span>
        </Link>
        <Link to="/Apropos" title="A propos" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faInfoCircle} size="lg" />
          <span>Info</span>
        </Link>
        <Link to="/contact" title="Contact" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faComment} size="lg" />
          <span>Contact</span>
        </Link>
        <Link to="/Gallery" title="Galerie" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faImages} size="lg" />
          <span>Galerie</span>
        </Link>
        <Link to="/billetterie" title="Billetterie" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faTicket} size="lg" />
          <span>Billetterie</span>
        </Link>
        <Link to="/Panier" title="Achat ou Don" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faShoppingCart} size="lg" />
          <span>Achat</span>
        </Link>
        <Link to="/articles" title="Articles" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faNewspaper} size="lg" />
          <span>Articles</span>
        </Link>
        <Link to="/blog" title="Blog" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faRss} size="lg" />
          <span>Blog</span>
        </Link>
        <Link to="/espace-membres" title="Espace membres" className="nav-item" onClick={closeMenu}>
          <FontAwesomeIcon icon={faUserLock} size="lg" />
          <span>Membres</span>
        </Link>
      </nav>

      <div className="theme-toggle-container">
        <button
          className="theme-toggle-button"
          onClick={toggleTheme}
          aria-label="Changer le mode"
        >
          <FontAwesomeIcon icon={faCircleHalfStroke} size="lg" />
        </button>
      </div>

      <div className="hamburger-menu">
        <button
          className="hamburger-icon-button"
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <FontAwesomeIcon icon={faBars} size="lg" />
        </button>
      </div>
    </header>
  );
};

export default Header;
